import { render, staticRenderFns } from "./facet-dropdown.vue?vue&type=template&id=1ba3998a&"
import script from "./facet-dropdown.vue?vue&type=script&lang=js&"
export * from "./facet-dropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports